import {
    useContext,
    useEffect,
    useState
} from 'react';
import { useRouter } from 'next/router';

import { 
  Card, 
  CardContent, 
  CardMedia, 
  Typography
} from '@mui/material';

import { RequestNextApi } from '../../../../api/Request';
import { ProgressContext } from '../../../../components/Context/progressContext';
import Header from '../../../../components/Header';
import { headerLink } from '../../../../navigation/function';
import { getCookie } from '../../../../utils/cookieHandle';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';
import { PAGES_SLUG } from '../../../../utils/static-pages/model';
import {resourceNavigation} from '../../../../navigation/resources';
import { CheckCircleOutline, School, Slideshow } from '@mui/icons-material';

export default function Courses() {
  const [courses, setArticleBlocks] = useState();
  const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

  const router = useRouter();

  const coursesLink = headerLink(resourceNavigation.courses, true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await RequestNextApi.post('/pages',
          {
            slug: PAGES_SLUG.COURSES,
            jwtToken: getCookie('jwt-token')
          }
        );
        if (res.data.success) {
          setArticleBlocks(res.data.page.articleBlocks[0].courses);
        } else {
          ShowNotification.error('Fetch page failed');    
        }
      } catch (error) {
        ShowNotification.error('Fetch page failed');
      }
    };
  
    const initPage = async () => {
      updateProgress({isLoading: true});
      await fetchPage();
      updateProgress({isLoading: false});
    };
  
    initPage();
  }, []);

  const handleClickCourse = (course) => {
    router.push(`/members/resources/courses/${course.slug}`);
  };

  const handleClickPurchase = (course) => {
    router.push(`/checkout/${course.sku}`);
  };

  if (!courses) {
    return <></>;
  }

  return (
    <div>
      <Header>
        <div>Members | {coursesLink}</div>
      </Header>
      <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 my-8'>
        {courses.map((item, index) => (
          <Card key={index} className='flex flex-col'>
            <CardMedia
              component="img"
              alt="Speaker Image"
              height="240"
              image={item?.thumbnailImage?.url}
              className='object-cover'
            />
            <CardContent className='flex flex-col flex-grow justify-between'>
              <div>
                <div className='text-xl'>
                  {item.title}
                </div>
                <div className='mt-3 space-y-1 text-gray-600'>
                  <div className='flex space-x-2'>
                    <Slideshow />
                    {parseFloat(item.price) ? (
                      <Typography>Paid Course: ${item.price}</Typography>
                    ) : (
                      <Typography>Fee Included as Member Benefit</Typography>
                    )}
                  </div>
                  {item.isCreditEligible && item.creditHours > 0 && (
                    <div className='flex space-x-2'>
                      <School />
                      <Typography>CE Credit Eligible ( {item.creditHours} {item.creditHours > 1 ? 'Hours' : 'Hour'} )</Typography>
                    </div>
                  )}
                  {item.designationsAsText && (
                    <div className='flex space-x-2'>
                      <CheckCircleOutline />
                      <Typography>{item.designationsAsText}</Typography>
                    </div>
                  )}
                </div>
              </div>
              {item.userHasAccess ? (
                <Typography 
                  className='mt-3 w-full text-center px-2 py-1 border border-solid border-grey-600 rounded-xl cursor-pointer'
                  onClick={() => handleClickCourse(item)}
                >
                  View
                </Typography>
              ) : (
                <Typography
                  className='mt-3 w-full text-center px-2 py-1 border border-solid border-grey-600 rounded-xl cursor-pointer'
                  onClick={() => handleClickPurchase(item)}
                >
                  Purchase
                </Typography>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
